import { render } from "./PokemonCard.vue?vue&type=template&id=0c4a08e4"
import script from "./PokemonCard.vue?vue&type=script&lang=js"
export * from "./PokemonCard.vue?vue&type=script&lang=js"

import "./PokemonCard.vue?vue&type=style&index=0&id=0c4a08e4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__